import {
    FETCH_52_WEEKS_BP,
    FETCH_52_WEEKS_BP_FAIL,
    FETCH_52_WEEKS_BP_FETCHING,
    FETCH_52_WEEKS_BP_SUCCESS,
    FETCH_DAY_BP,
    FETCH_DAY_BP_FAIL,
    FETCH_DAY_BP_SUCCESS,
    FETCH_MULTIPLE_DAYS_BP,
    FETCH_MULTIPLE_DAYS_BP_FAIL,
    FETCH_MULTIPLE_DAYS_BP_FETCHING,
    FETCH_MULTIPLE_DAYS_BP_SUCCESS,
    SET_CURRENT_BP_TAB,
    FETCH_52_WEEKS_BP_REPORT,
    FETCH_52_WEEKS_BP_REPORT_FETCHING,
    FETCH_52_WEEKS_BP_REPORT_SUCCESS,
    FETCH_52_WEEKS_BP_REPORT_FAIL,
    SET_CURRENT_BP_PAGE_DATE,
    FETCH_DAY_BP_FETCHING,
    DELETE_BP_ENTRY,
    DELETING_BP_SUCCESS,
    ADD_BPM,
    ADD_BPM_FAIL,
    ADD_BPM_START,
    ADD_BPM_SUCCESS,
    CLEAN_UP_BP_DATA,
    UPDATE_BPM_NOTE,
    UPDATE_BPM_NOTE_START,
    UPDATE_BPM_NOTE_SUCCESS,
    UPDATE_BPM_NOTE_FAIL
} from 'actions/bloodPressureActions';
import { TABS } from 'Weight/WeightUtils';
import { MULTIPLE_DAYS_REQUEST_PERIOD_KEYS } from 'Reports/ReportUtils';
import DateFormatter from 'utils/date/DateFormatter';

const INITIAL_STATE = {
    oneDay: {
        entries: {},
        isFetching: null,
        didFetchFail: false
    },
    oneMonth: {
        entries: {},
        isFetching: null,
        didFetchFail: false
    },
    sevenDays: {
        entries: {},
        isFetching: null,
        didFetchFail: false
    },
    fourWeeks: {
        entries: {},
        isFetching: null,
        didFetchFail: false
    },
    fiftyTwoWeeks: {
        entries: {},
        isFetching: null,
        didFetchFail: false
    },
    fiftyTwoWeeksReport: {
        entries: {},
        isFetching: null,
        didFetchFail: false
    },
    currentTab: TABS.ONE_DAY,
    currentPageDate: null,
    addBPMFetching: null,
    noteUpdating: false,
    noteUpdateFailed: false
};

// ======= Fetching Handlers =======
const fetchDayBPFetching = (state) => {
    return {
        ...state,
        oneDay: { ...state.oneDay },
        isFetching: true,
        didFetchFail: false
    };
};

const fetchDayBPSuccess = (state, action) => {
    return {
        ...state,
        oneDay: {
            entries: { ...state.oneDay.entries, [action.date]: action.data },
            isFetching: false,
            didFetchFail: false
        }
    };
};

const fetchDayBPFail = (state, action) => {
    delete state.bloodPressure.oneDay[action.date];
    return {
        ...state,
        oneDay: {
            entries: { ...state.oneDay.entities },
            isFetching: false,
            didFetchFail: true
        }
    };
};

const setCurrentBPTabState = (state, action) => {
    return {
        ...state,
        currentTab: action.currentTab
    };
};

const setCurrentBPPageState = (state, action) => {
    let todayDate = DateFormatter.formatISODate(new Date());
    let verifiedCurrentDatePage = action.currentPageDate > todayDate ? todayDate : action.currentPageDate;
    return {
        ...state,
        currentPageDate: verifiedCurrentDatePage
    };
};

const fetch52WeeksBPFetching = (state) => {
    return {
        ...state,
        fiftyTwoWeeks: {
            ...state.fiftyTwoWeeks,
            isFetching: true,
            didFetchFail: false
        }
    };
};

const fetch52WeeksBPReportFetching = (state) => {
    return {
        ...state,
        fiftyTwoWeeks: {
            ...state.fiftyTwoWeeks,
            isFetching: true,
            didFetchFail: false
        }
    };
};

const fetchMultipleDaysBPFetching = (state, action) => {
    let keyProp = action.dateRange ? action.dateRange : MULTIPLE_DAYS_REQUEST_PERIOD_KEYS.SEVEN_DAYS;
    return {
        ...state,
        [keyProp]: {
            ...state[keyProp],
            isFetching: true,
            didFetchFail: false
        }
    };
};

const fetch52WeeksBPSuccess = (state, action) => {
    return {
        ...state,
        fiftyTwoWeeks: {
            ...state.fiftyTwoWeeks,
            entries: {
                ...state.fiftyTwoWeeks.entries,
                [action.date]: action.data
            },
            isFetching: false,
            didFetchFail: false
        }
    };
};

const fetch52WeeksBPReportSuccess = (state, action) => {
    return {
        ...state,
        fiftyTwoWeeksReport: {
            ...state.fiftyTwoWeeksReport,
            [action.endDate]: action.data,
            isFetching: false,
            didFetchFail: false
        }
    };
};

const fetchMultipleDaysBPSuccess = (state, action) => {
    let keyProp = action.dateRange ? action.dateRange : MULTIPLE_DAYS_REQUEST_PERIOD_KEYS.SEVEN_DAYS;
    return {
        ...state,
        [keyProp]: {
            ...state[keyProp],
            entries: {
                ...state[keyProp].entries,
                [action.date]: action.data
            },
            isFetching: false,
            didFetchFail: false
        }
    };
};

const fetch52WeeksBPFail = (state) => {
    return {
        ...state,
        fiftyTwoWeeks: {
            ...state.fiftyTwoWeeks,
            isFetching: false,
            didFetchFail: true
        }
    };
};
const fetch52WeeksBPReportFail = (state) => {
    return {
        ...state,
        fiftyTwoWeeksReport: {
            ...state.fiftyTwoWeeksReport,
            isFetching: false,
            didFetchFail: true
        }
    };
};

const fetchMultipleDaysBPFail = (state, action) => {
    let keyProp = action.dateRange ? action.dateRange : MULTIPLE_DAYS_REQUEST_PERIOD_KEYS.SEVEN_DAYS;
    return {
        ...state,
        [keyProp]: {
            ...state[keyProp],
            isFetching: false,
            didFetchFail: true
        }
    };
};

const addBPMStart = (state) => {
    return {
        ...state,
        addBPMFetching: true
    };
};

const addBPMFinish = (state) => {
    return {
        ...state,
        addBPMFetching: false
    };
};

const cleanUpData = (state) => {
    return {
        ...INITIAL_STATE,
        currentTab: state.currentTab
    };
};

const deletedBPEntry = (state) => {
    // All averages and data is calculated on the API. So we reload all data.
    return { ...INITIAL_STATE, currentTab: state.currentTab };
};

const updateBPMNoteStart = (state) => {
    return {
        ...state,
        noteUpdating: true
    };
};

const updateBPMNoteSuccess = (state) => {
    return {
        ...state,
        noteUpdating: false,
        noteUpdateFailed: false
    };
};

const updateBPMNoteFail = (state) => {
    return {
        ...state,
        noteUpdating: false,
        noteUpdateFailed: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DAY_BP_FETCHING]: fetchDayBPFetching,
    [FETCH_DAY_BP_SUCCESS]: fetchDayBPSuccess,
    [FETCH_DAY_BP_FAIL]: fetchDayBPFail,
    [SET_CURRENT_BP_TAB]: setCurrentBPTabState,
    [SET_CURRENT_BP_PAGE_DATE]: setCurrentBPPageState,
    [FETCH_52_WEEKS_BP_FETCHING]: fetch52WeeksBPFetching,
    [FETCH_52_WEEKS_BP_SUCCESS]: fetch52WeeksBPSuccess,
    [FETCH_52_WEEKS_BP_FAIL]: fetch52WeeksBPFail,
    [FETCH_52_WEEKS_BP_REPORT_FETCHING]: fetch52WeeksBPReportFetching,
    [FETCH_52_WEEKS_BP_REPORT_SUCCESS]: fetch52WeeksBPReportSuccess,
    [FETCH_52_WEEKS_BP_REPORT_FAIL]: fetch52WeeksBPReportFail,
    [FETCH_MULTIPLE_DAYS_BP_FETCHING]: fetchMultipleDaysBPFetching,
    [FETCH_MULTIPLE_DAYS_BP_SUCCESS]: fetchMultipleDaysBPSuccess,
    [FETCH_MULTIPLE_DAYS_BP_FAIL]: fetchMultipleDaysBPFail,
    [ADD_BPM_START]: addBPMStart,
    [ADD_BPM_SUCCESS]: addBPMFinish,
    [ADD_BPM_FAIL]: addBPMFinish,
    [CLEAN_UP_BP_DATA]: cleanUpData,
    [DELETING_BP_SUCCESS]: deletedBPEntry,
    [UPDATE_BPM_NOTE_START]: updateBPMNoteStart,
    [UPDATE_BPM_NOTE_SUCCESS]: updateBPMNoteSuccess,
    [UPDATE_BPM_NOTE_FAIL]: updateBPMNoteFail
};

// ======= Default Action =======
export default function bloodPressure(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function setCurrentBPPageDate(currentPageDate) {
    return {
        type: SET_CURRENT_BP_PAGE_DATE,
        currentPageDate
    };
}

export function deleteBPEntry(bloodPressure, fetchLatestData) {
    return {
        type: DELETE_BP_ENTRY,
        bloodPressure,
        fetchLatestData
    };
}

export function fetchDayBP(date) {
    return {
        type: FETCH_DAY_BP,
        date: date
    };
}

export function setCurrentBPTab(currentTab) {
    return {
        type: SET_CURRENT_BP_TAB,
        currentTab: currentTab
    };
}

export function fetch52WeeksBPData(dates) {
    return {
        type: FETCH_52_WEEKS_BP,
        dates
    };
}

export function fetch52WeeksBPReportData(dates) {
    return {
        type: FETCH_52_WEEKS_BP_REPORT,
        dates
    };
}

export function fetchMultipleDaysBP(dates, dateRange) {
    return {
        type: FETCH_MULTIPLE_DAYS_BP,
        dates,
        dateRange
    };
}

export function addBPM(payload, currentDate, actionToDispatch, saveBPM, fetchData, fetchLatestData) {
    return {
        type: ADD_BPM,
        payload: payload,
        currentDate: currentDate,
        actionToDispatch: actionToDispatch,
        saveBPM: saveBPM,
        fetchData,
        fetchLatestData
    };
}

export function cleanUpBPMData() {
    return {
        type: CLEAN_UP_BP_DATA
    };
}

export function updateBPMNote(payload, fetchBPData) {
    return {
        type: UPDATE_BPM_NOTE,
        payload: payload,
        fetchBPData
    };
}

// ======= Selectors =======
export const getDayBP = (state, date) => {
    const entry = state.bloodPressure.oneDay.entries[date];
    return entry ? state.bloodPressure.oneDay.entries[date].bloodPressureMeasurements : null;
};

export const isDayBPFetching = (state) => {
    return state.bloodPressure.oneDay.isFetching;
};

export const getCurrentBPTab = (state) => {
    return state.bloodPressure.currentTab;
};

export const get52WeeksBPSummaries = (state, date) => {
    return state.bloodPressure.fiftyTwoWeeks.entries[date]
        ? state.bloodPressure.fiftyTwoWeeks.entries[date].measurementSummaries
        : null;
};

export const get52WeeksBPSummariesReportData = (state, date) => {
    return state.bloodPressure.fiftyTwoWeeksReport[date]
        ? state.bloodPressure.fiftyTwoWeeksReport[date].measurementSummaries
        : null;
};

export const getDailyBPSummaries = (state, date) => {
    return state.bloodPressure.sevenDays.entries[date]
        ? state.bloodPressure.sevenDays.entries[date].measurementSummaries
        : null;
};

export const getSevenDaysDailyBPSummaries = (state, date) => {
    return state.bloodPressure.sevenDays.entries[date]
        ? state.bloodPressure.sevenDays.entries[date].measurementSummaries
        : null;
};

export const isDailyBPSummariesFetching = (state) => {
    return state.bloodPressure.sevenDays.isFetching;
};

export const didDailyBPSummariesFetchFail = (state) => {
    return state.bloodPressure.sevenDays.didFetchFail;
};

export const isDayBPEntriesFetching = (state) => {
    return state.bloodPressure.isFetching;
};

export const is52WeeksBPFetching = (state) => {
    return state.bloodPressure.fiftyTwoWeeks.isFetching;
};

export const isFourWeeksBPFetching = (state) => {
    return state.bloodPressure.fourWeeks.isFetching;
};

export const getFourWeeksBPSummaries = (state, date) => {
    return state.bloodPressure.fourWeeks.entries[date]
        ? state.bloodPressure.fourWeeks.entries[date].measurementSummaries
        : null;
};

export const getCurrentPageDate = (state) => {
    return state.bloodPressure.currentPageDate;
};

export const isAddBPMInProgress = (state) => {
    return state.bloodPressure.addBPMFetching;
};

export const hasNoteUpdateFailed = (state) => {
    return state.bloodPressure.noteUpdateFailed;
};
